/* eslint @typescript-eslint/naming-convention: 0 */
import { css, SerializedStyles } from '@emotion/react';

interface MarginsProps {
  mx?: string | number;
  mxT?: string | number;
  mxM?: string | number;
  ml?: string | number;
  mlT?: string | number;
  mlM?: string | number;
  m?: string | number;
  mT?: string | number;
  mM?: string | number;
  mr?: string | number;
  mrT?: string | number;
  mrM?: string | number;
  my?: string | number;
  myT?: string | number;
  myM?: string | number;
  mt?: string | number;
  mtT?: string | number;
  mtM?: string | number;
  mb?: string | number;
  mbT?: string | number;
  mbM?: string | number;
  theme: {
    spacings: { [key: string]: string | number };
    media: {
      tablet: string;
      mobile: string;
    };
  };
}

const margins = ({
  mx,
  mxT,
  mxM,
  ml,
  mlT,
  mlM,
  m,
  mT,
  mM,
  mr,
  mrT,
  mrM,
  my,
  myT,
  myM,
  mt,
  mtT,
  mtM,
  mb,
  mbT,
  mbM,
  theme
}: MarginsProps): SerializedStyles => {
  const _mxT = mxT || mx;
  const _mxM = mxM || mxT || mx;

  const _mlT = mlT || ml;
  const _mlM = mlM || mlT || ml;

  const _mT = mT || m;
  const _mM = mM || mT || m;

  const _mrT = mrT || mr;
  const _mrM = mrM || mrT || mr;

  const _myT = myT || my;
  const _myM = myM || myT || my;

  const _mtT = mtT || mt;
  const _mtM = mtM || mtT || mt;

  const _mbT = mbT || mb;
  const _mbM = mbM || mbT || mb;

  return css`
    margin-left: ${ml !== undefined
      ? theme.spacings[ml]
      : ml || mx !== undefined
      ? theme.spacings[mx]
      : mx || m !== undefined
      ? theme.spacings[m]
      : m || 0} !important;
    margin-right: ${mr !== undefined
      ? theme.spacings[mr]
      : mr || mx !== undefined
      ? theme.spacings[mx]
      : mx || m !== undefined
      ? theme.spacings[m]
      : m || 0} !important;
    margin-top: ${mt !== undefined
      ? theme.spacings[mt]
      : mt || my !== undefined
      ? theme.spacings[my]
      : my || m !== undefined
      ? theme.spacings[m]
      : m || 0} !important;
    margin-bottom: ${mb !== undefined
      ? theme.spacings[mb]
      : mb || my !== undefined
      ? theme.spacings[my]
      : my || m !== undefined
      ? theme.spacings[m]
      : m || 0} !important;
    ${theme.media.tablet} {
      margin-left: ${_mlT !== undefined
        ? theme.spacings[_mlT]
        : _mlT || _mxT !== undefined
        ? theme.spacings[_mxT]
        : _mxT || _mT !== undefined
        ? theme.spacings[_mT]
        : _mT || 0} !important;
      margin-right: ${_mrT !== undefined
        ? theme.spacings[_mrT]
        : _mrT || _mxT !== undefined
        ? theme.spacings[_mxT]
        : _mxT || _mT !== undefined
        ? theme.spacings[_mT]
        : _mT || 0} !important;
      margin-top: ${_mtT !== undefined
        ? theme.spacings[_mtT]
        : _mtT || _myT !== undefined
        ? theme.spacings[_myT]
        : _myT || _mT !== undefined
        ? theme.spacings[_mT]
        : _mT || 0} !important;
      margin-bottom: ${_mbT !== undefined
        ? theme.spacings[_mbT]
        : _mbT || _myT !== undefined
        ? theme.spacings[_myT]
        : _myT || _mT !== undefined
        ? theme.spacings[_mT]
        : _mT || 0} !important;
    }
    ${theme.media.mobile} {
      margin-left: ${_mlM !== undefined
        ? theme.spacings[_mlM]
        : _mlM || _mxM !== undefined
        ? theme.spacings[_mxM]
        : _mxM || _mM !== undefined
        ? theme.spacings[_mM]
        : _mM || 0} !important;
      margin-right: ${_mrM !== undefined
        ? theme.spacings[_mrM]
        : _mrM || _mxM !== undefined
        ? theme.spacings[_mxM]
        : _mxM || _mM !== undefined
        ? theme.spacings[_mM]
        : _mM || 0} !important;
      margin-top: ${_mtM !== undefined
        ? theme.spacings[_mtM]
        : _mtM || _myM !== undefined
        ? theme.spacings[_myM]
        : _myM || _mM !== undefined
        ? theme.spacings[_mM]
        : _mM || 0} !important;
      margin-bottom: ${_mbM !== undefined
        ? theme.spacings[_mbM]
        : _mbM || _myM !== undefined
        ? theme.spacings[_myM]
        : _myM || _mM !== undefined
        ? theme.spacings[_mM]
        : _mM || 0} !important;
    }
  `;
};

export default margins;
